'use client';

import {
  BodyLinkV3,
  LayoutGrid,
  TypographyRhythm,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useLocale, useTranslations } from 'next-intl';

const Content = (): JSX.Element => {
  const selectedLocale = useLocale();
  const t = useTranslations();
  return (
    <LayoutGrid>
      <div className="col-main">
        <TypographyRhythm>
          <TypographyV3 variant="h1" Element="h1">
            {t('accessibility_title')}
          </TypographyV3>

          <TypographyV3>
            {t.rich('accessibility_body_1', {
              // @ts-expect-error -- mismatched types
              ouraringDotCom: (
                <BodyLinkV3
                  href={`https://ouraring.com/${selectedLocale}`}
                  color="inherit"
                >
                  ouraring.com
                </BodyLinkV3>
              ),
            })}
          </TypographyV3>

          <TypographyV3>
            {t.rich('accessibility_body_2', {
              // @ts-expect-error -- mismatched types
              contactUs: (
                <BodyLinkV3
                  href="https://support.ouraring.com/hc/requests/new"
                  color="inherit"
                  target="_blank"
                >
                  {t('accessibility_contact_us')}
                </BodyLinkV3>
              ),
            })}
          </TypographyV3>
        </TypographyRhythm>
      </div>
    </LayoutGrid>
  );
};

export default Content;
